module.exports = __webpack_public_path__ + "static/media/badge-googleplay2.2d736253.svg";